export default __webpack_public_path__ + "static/media/heat-8.cfa128cd.png";